import React from 'react';
import PropTypes from 'prop-types';

import PostPreview from './PostPreview';

import './styles/OthersPosts.scss';

const OthersPosts = ({ othersPosts }) => {
  const renderOthersPosts = (othersPosts) => {
    return othersPosts.map((node, index) => {

      const { banner } = node.frontmatter;
      const postBanner = (!banner) ? defaultBanner : banner;
      return (
        <PostPreview 
          key={index}
          data={node}
          image={banner.childImageSharp.sizes}
          className="postPreview--thirdWidth"
        />
      )
    });
  }

  return (
    <div className="othersPosts">
      { renderOthersPosts(othersPosts) }
    </div>
  )
};

OthersPosts.propTypes = {
  othersPosts: PropTypes.array,
}

export default OthersPosts;



// WEBPACK FOOTER //
// ./src/components/OthersPosts.jsx